document.addEventListener("DOMContentLoaded", function () {
  const container =
    document.querySelector(".ajax-cart__form") ||
    document.querySelector(".gsAppContainer") ||
    document.body;

  if (!container) return;
  let isUpdating = false;

  function formatCurrency(value) {
    return "$" + parseFloat(value).toFixed(2);
  }

  function updateCartItem(key, qty) {
    isUpdating = true;
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty }),
    })
      .then((res) => res.json())
      .then((cart) => {
        if (!cart || !cart.items) return;
        cart.items.forEach((item) => {
          const input = document.querySelector(`[data-item-key="${item.key}"]`);
          if (input) {
            input.value = item.quantity;
            const priceEl = input
              .closest(".ajax-cart__cart-item")
              ?.querySelector(".js-cart-subtotal");
            if (priceEl)
              priceEl.innerText = formatCurrency(item.final_line_price / 100);
          }
        });
        const totalEls = document.querySelectorAll(
          ".js-cart-summary .js-cart-subtotal, .js-cart-summary .cart-original-total"
        );
        totalEls.forEach(
          (el) =>
            (el.innerText = formatCurrency(cart.items_subtotal_price / 100))
        );
        document.querySelectorAll(".js-cart-count").forEach(
          (el) => (el.innerText = `(${cart.item_count})`)
        );
      })
      .catch((err) => console.error("Cart update failed:", err))
      .finally(() => {
        isUpdating = false;
      });
  }
  container.addEventListener("click", function (e) {
    if (isUpdating) return;
    const btn = e.target.closest(
      "[data-ajax-qty-increase], [data-ajax-qty-decrease]"
    );
    if (!btn) return;
    const itemWrap = btn.closest(".ajax-cart__cart-item");
    const input = itemWrap?.querySelector("input[data-item-key]");
    if (!input) return;
    const key = input.dataset.itemKey;
    let qty = parseInt(input.value) || 1;
    const maxQty = parseInt(input.getAttribute("data-limit")) || null;
    clearInlineError(itemWrap);
    if (btn.hasAttribute("data-ajax-qty-increase")) {
      if (maxQty && qty >= maxQty) {
        showInlineError(
          itemWrap,
          `Only ${maxQty} item${maxQty > 1 ? "s" : ""} available in stock.`
        );
        return;
      }
      qty++;
    } else if (btn.hasAttribute("data-ajax-qty-decrease")) {
  qty = qty - 1;

  // 👇 if qty goes below 1, remove the item completely
  if (qty < 1) {
    updateCartItem(key, 0); // Shopify removes the item when quantity = 0
    itemWrap.style.opacity = "0.5"; // Optional small visual fade
    setTimeout(() => {
      itemWrap.remove(); // remove from DOM after animation
    }, 500);
    return; // stop here — no need to continue
  }
}
input.value = qty;
updateCartItem(key, qty);

  });
  container.addEventListener("change", function (e) {
    if (isUpdating) return;
    const input = e.target.closest("input[data-item-key]");
    if (!input) return;
    const itemWrap = input.closest(".ajax-cart__cart-item");
    clearInlineError(itemWrap);
    let qty = parseInt(input.value) || 1;
    const key = input.dataset.itemKey;
    const maxQty = parseInt(input.getAttribute("data-limit")) || null;
    if (maxQty && qty > maxQty) {
      showInlineError(
        itemWrap,
        `Only ${maxQty} item${maxQty > 1 ? "s" : ""} available in stock.`
      );
      qty = maxQty;
      input.value = qty;
    }
    updateCartItem(key, qty);
  });
  function showInlineError(itemWrap, message) {
    let errorEl = itemWrap.querySelector(".inline-error");
    if (!errorEl) {
      errorEl = document.createElement("div");
      errorEl.className = "inline-error";
      itemWrap.appendChild(errorEl);
    }
    errorEl.innerText = message;
     errorEl.style.transition = "opacity 0.5s ease";
     setTimeout(() => {
      if (errorEl) {
        errorEl.style.opacity = "0";
        setTimeout(() => errorEl.remove(), 500);
      }
    }, 3000);
  }
  function clearInlineError(itemWrap) {
    const errorEl = itemWrap?.querySelector(".inline-error");
    if (errorEl) errorEl.remove();
  }
});
